import TopLineSchema from 'sitemodel/schema/components/TopLineSchema'
import schemaToTypeGuard from 'sitemodel/schema/util/schemaToTypeGuard'
import schemaToReactType from 'sitemodel/schema/util/schemaToReactType'

export type TopLineProps = schemaToReactType<typeof TopLineSchema>

export const TopLineTypeGuard = schemaToTypeGuard(TopLineSchema)
